export default function NoteDisplay({ text }) {
  if (!text) return null;

  const lines = text.split("\n");

  return (
    <div style={{ fontSize: 14, lineHeight: 1.9, color: "#1A2E3B" }}>
      {lines.map((line, i) => {
        const isSectionHeader =
          line.startsWith("**S") ||
          line.startsWith("**O") ||
          line.startsWith("**A") ||
          line.startsWith("**P") ||
          line.startsWith("S (") ||
          line.startsWith("O (") ||
          line.startsWith("A (") ||
          line.startsWith("P (");

        const cleaned = line.replace(/\*\*/g, "");

        if (isSectionHeader) {
          return (
            <div key={i} style={{
              fontWeight: 700,
              color: "#0E9F7E",
              fontSize: 13,
              letterSpacing: 1,
              textTransform: "uppercase",
              marginTop: i === 0 ? 0 : 20,
              marginBottom: 6,
              borderBottom: "1px solid #E8F4F0",
              paddingBottom: 6,
            }}>
              {cleaned}
            </div>
          );
        }

        if (line.trim() === "") return <div key={i} style={{ height: 4 }} />;

        const boldFormatted = cleaned.split(/(\*[^*]+\*)/).map((part, j) =>
          part.startsWith("*") && part.endsWith("*")
            ? <strong key={j}>{part.slice(1, -1)}</strong>
            : part
        );

        return (
          <div key={i} style={{ marginBottom: 2 }}>{boldFormatted}</div>
        );
      })}
    </div>
  );
}
